import { avatarUpdaterSaga } from '@members/avatar-updater/../../@engage/avatar-updater/sagas';
import { sagas as driftSagas } from '@peloton/drift';
import { errorReportingSaga } from '@peloton/error-reporting';
import { fetcherSaga } from '@peloton/redux-fetch';
import trackSaga from '@engage/analytics-middleware/baseProperties';
import { challengesWatcherSaga } from '@engage/challenges/sagas';
import classDetailSaga from '@engage/class-detail/sagas';
import { memberSaga } from '@engage/members/sagas';
import settingsSaga from '@engage/settings/sagas';
import { subscriptionSaga } from '@engage/subscriptions';
import { workoutHistorySaga } from '@engage/workout-history';
import authSaga from '@members/auth/sagas';
import { classesSaga } from '@members/classes';
import facebookSaga from '@members/facebook/sagas';
import guestPassSaga from '@members/guest-pass/sagas';
import { memberSearchSaga } from '@members/member-search';
import { modalWatcherSaga } from '@members/modal';
import onDemandSaga from '@members/on-demand-modal/sagas';
import { achievementsPageSaga } from '@members/pg-achievements/sagas';
import { forgotPasswordFormSaga } from '@members/pg-auth/ForgotPassword/sagas';
import { resetPasswordFormSaga } from '@members/pg-auth/ResetPassword/sagas';
import completeProfileSaga from '@members/pg-complete-profile/sagas';
import { libraryPageWatcherSaga } from '@members/pg-library/Filters/sagas';
import { overviewPageSaga } from '@members/pg-overview/sagas';
import preferencesSaga from '@members/pg-preferences/sagas';
import { combinedVideoPageSaga as videoPageSaga } from '@members/pg-video';
import workoutsSaga from '@members/pg-workouts/sagas';
import workoutDetailsPageSaga from '@members/pg-workouts/workout-details/sagas';
import { workoutHistoryPageSaga } from '@members/pg-workouts/workout-history';
import { referralsSaga } from '@members/referrals';
import membersSettingsSaga from '@members/settings/sagas';
import memberMapperSaga from '@members/user-mapper/sagas/memberMapper';
import userMapperSaga from '@members/user-mapper/sagas/userMapper';

import { appSaga } from './appSaga';

export const toStoreSagas = () => [
  appSaga,
  achievementsPageSaga,
  authSaga,
  avatarUpdaterSaga,
  challengesWatcherSaga,
  classDetailSaga,
  classesSaga,
  completeProfileSaga,
  driftSagas,
  errorReportingSaga,
  facebookSaga,
  fetcherSaga,
  forgotPasswordFormSaga,
  guestPassSaga,
  libraryPageWatcherSaga,
  memberMapperSaga,
  memberSaga,
  membersSettingsSaga,
  memberSearchSaga,
  modalWatcherSaga,
  onDemandSaga,
  overviewPageSaga,
  preferencesSaga,
  referralsSaga,
  resetPasswordFormSaga,
  settingsSaga,
  subscriptionSaga,
  trackSaga,
  userMapperSaga,
  videoPageSaga,
  workoutDetailsPageSaga,
  workoutHistoryPageSaga,
  workoutHistorySaga,
  workoutsSaga,
];
